module.exports = __webpack_public_path__ + "img/eye-opened.13b05b88.svg";